module.exports = __webpack_public_path__ + "img/establishment-role.fd592c54.svg";